/* eslint-disable max-len */
/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useEffect, useRef, useState } from 'react'
import Button from '../../../components/Button'
import ErrorMessage from '../../../components/ErrorMessage';
const EmailTemplate = ({ handleSubmit, loading, handleClose, noteFocus
    , setNoteFocus
    , note
    , setNote
    , noteError
    , setNoteError }) => {
    // const [status, setStatus] = useState('');
    return (
        <div className=" w-[352px] bg-white">
            <div className="flex pb-4 justify-between">
                <h1 className="text-lg font-normal text-[#1f1f1f]">
                    Login as Merchant
                </h1>
                <img src="/assets/images/close-24px.svg" data-testid="close-button" onClick={handleClose} className=' mr-[-4px]' alt="" />
            </div>
            <div className={`relative pl-[16px] py-[16px] mt-4 h-[120px] w-[352px] border 
                     ${noteError ? 'border-[#FC4523]' : 'border-[#DDD] mb-[34px]'}`}>
                <textarea
                    id="note"
                    data-testid="note"
                    onFocusCapture={() => setNoteFocus(true)}
                    onBlurCapture={() => setNoteFocus(false)}
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    onFocus={() => setNoteError('')}
                    className={`h-[90px] caret-[#9e2063ab] text-justify mt-1 w-[278px] resize-none 
                            focus:outline-none focus:border-0 text-[14px] font-semibold leading-[22px] overflow-y-auto sidebar
                            ${noteError ? 'text-[#FC4523]' : 'text-[#1F1F1F]'}`}
                />
                <label htmlFor="note"
                    className={`absolute mt-1 left-4 transition-all duration-300 
                            ${noteError ? 'text-[#FC4523]' : 'text-[#1F1F1F]'}  
                            ${note?.length > 0 || noteFocus ? '-translate-y-3.5 font-normal text-[12px] leading-[16px]'
            : 'top-4 text-[14px] font-semibold leading-[22px]'} `}>
                    Reason for Accessing
                </label>
                <p className={`absolute bottom-0 right-0 p-2 font-semibold text-[14px] leading-[22px] 
                        ${noteError ? 'text-[#FC4523]' : 'text-[#8E8E8E]'}`}>{note?.length || 0}/500</p>
            </div>
            {noteError &&
                <ErrorMessage classKey='font-normal text-[12px] leading-[18px] mt-1 text-[#FC4523] absolute'
                    error={noteError} message={noteError} />}
            <p className="text-sm mt-[34px] font-normal text-[#4B4B4B]">
                Please note: An email will be sent to the merchant notifying them of your access to their account.
            </p>
            <div className="flex justify-end space-x-2 mt-6 items-center">
                <button className="px-4 rounded-[12px] text-primary items-center" onClick={() => handleClose()} data-testid="cancel-btn">Cancel</button>
                <>
                    <Button
                        handleClick={handleSubmit}
                        loading={loading}
                        // disabled={loading}
                        text="Login"
                        classKey="px-4 py-[10px] bg-primary text-white rounded-[12px]"
                        type="submit"
                        testId="confirm-btn"
                    /></>
            </div>
        </div>
    )
}
export default EmailTemplate